import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import Login from './pages/Login'
import './global.css'
import './assets/styles/main.scss'
import Vehicles from './pages/Vehicles'
import PrivateRoute from './components/PrivateRoute'
import Importers from './pages/Importers'
import Store from './context/global_context'
import DtcApp from './pages/vehicles/dtcs'
import TatDtcMappings from './pages/vehicles/dtcs/TaTmappings'
import DtcEdit from './pages/vehicles/dtcs/DtcEdit'
import TatConnectorMapping from './pages/vehicles/dtcs/TaTmappings/ConnectorMapping'
import ConnectorViews from './pages/vehicles/connector_views'
import ConnectorViewEdit from './pages/vehicles/connector_views/edit'
import ConnectorViewNew from './pages/vehicles/connector_views/new'
import ConnectorViewEditMappings from './pages/vehicles/connector_views/edit_mappings'
import Administration from './pages/administration'
import EditVehicle from './pages/vehicles/edit'
import CreateNewVehicle from './pages/vehicles/new'
import PowerDistributions from './pages/vehicles/power_distributions'
import Auth from './pages/auth'
import NotPermitted from './pages/not_permitted'
import LogoutSuccess from './pages/logout_success'
import SystemAndSubSystem from './pages/system_and_sub_system'
import InlinesConnections from './pages/vehicles/inlines'
import ModulesPage from './pages/vehicles/modules'
import DevicePage from './pages/vehicles/devices'
import InSpectionPointsPage from './pages/vehicles/inspection_points'
import WirePage from './pages/vehicles/wire'
import ConnectorPage from './pages/vehicles/connector'
import SalesCodesPage from './pages/vehicles/sales_code'
import FunctionalDiagramPage from './pages/vehicles/functional_diagram'
import HarnessListPage from './pages/vehicles/harness_list'
import CircuitPage from './pages/vehicles/circuit'
import FunctionalDiagramEditPage from './pages/vehicles/functional_diagram/edit'
import ConnectorViewMappingsPrintPage from './pages/vehicles/connector_views/print'
import NotFound from './pages/404'
import CreateDtcForm from './components/dtcs/TATMappings/DtcEdit/CreateDtcForm'
import DeviceConnectionPage from './pages/vehicles/device_connections'
import DtcMappingErrorsPage from './pages/vehicles/dtc_mapping_errors'
import GraphMissingImagesPage from './pages/vehicles/graph_missing_images'
import UsageReport from './pages/usage_report'
import PromoteChangesPage from './pages/promote_changes'
import TracerPreviewPage from './pages/promote_changes/tracer_preview'
import DeletePromotedChangesPage from './pages/promote_changes/delete'
import VisualAidPage from './pages/vehicles/visual_aids'
import VehicleWorkspaceLayout from './antd/vehicle/VehicleWorkspaceLayout'
import { VehicleProvider } from './context/vehicle_context'
import TatStore from './components/dtcs/TATMappings/context/context'
import DtcsListing from './components/dtcs/TATMappings/DtcsListing'
import TracerMapping from './components/dtcs/TracerMapping'
import TracerMappingStore from './components/dtcs/TracerMapping/context/context'
import Memos from './components/dtcs/Memos'
import MemoStore from './components/dtcs/Memos/context/context'
import DefPlugin from './components/vehicle/plugin/def'
import PluginStore from './components/vehicle/plugin/def/context/context'
import SalesCodeComplexity from './components/vehicle/plugin/sales_code_complexity'
import SalesCodeComplexityStore from './components/vehicle/plugin/sales_code_complexity/context/context'
import CapitalHarness from './components/vehicle/plugin/capital_harness'
import CapitalHarnessStore from './components/vehicle/plugin/capital_harness/context/context'
import VehicleCSVDependencies from './pages/vehicles/csv_dependencies'
import DemoPayload from './pages/vehicles/demo_payload'
import Customer from './components/administration/customer'
import CustomerStore from './components/administration/customer/context/context'

export default function App() {

  return (
    <BrowserRouter>
      <Routes>
        {/* Layout Routes */}
        <Route path="/" element={
            <Store>
                <Layout />
            </Store>
        } key={'home'}>
            {/* Public Routes */}
            <Route path="users/sign_in" index element={<Login />} key={'login'} />
            <Route path={`auth/`} element={<Auth />} key={'auth'} />
            <Route path="not_permitted/" element={<NotPermitted />} key={'not_permitted'} />
            <Route path="logout_success/" element={<LogoutSuccess />} key={'logout_success'} />
          
            {/* Protected Routes */}
            <Route exact element={
                <VehicleProvider>
                    <PrivateRoute />
                </VehicleProvider>
            }>
                {/* Nested Routes */}
                <Route path="vehicles/" element={<Vehicles />} key={'vehicles'} />
                <Route path="vehicles/new" element={<CreateNewVehicle />} key={'vehicles_create'} />

                <Route path="vehicles/:vehicle" element={ <VehicleWorkspaceLayout /> } >
                  <Route path="importers" element={ <Importers /> } key={'vehicle_importers'} />
                  <Route path="edit_vehicle" element={<EditVehicle />} key={'vehicles_edit'} />
                  <Route path="csv_dependencies" element={<VehicleCSVDependencies />} key={'vehicles_edit'} />
                  <Route path="demo_payload" element={<DemoPayload />} key={'vehicles_edit'} />
                  {/* DTCs Submenu */}
                  <Route path={`dtcs/listing`} element={<TatStore><DtcsListing /></TatStore>} key={'dtc_listing'} />
                  <Route path={`dtcs/listing/:dtc_id/edit`} element={<DtcEdit />} key={'tat_dtc_edit'} />
                  <Route path={`dtcs/listing/new`} element={<CreateDtcForm />} key={'tat_dtc_new'} />
                  <Route path={`dtcs/listing/mappings`} element={<TatDtcMappings />} key={'tat_dtcs_mappings'} />
                  <Route path={`dtcs/listing/mappings/:connector_id`} element={<TatConnectorMapping />} key={'tat_dtcs_connector_mappings'} />

                  <Route path={`dtcs/tracer_mapping`} element={<TracerMappingStore><TracerMapping /></TracerMappingStore>} key={'dtc_tracer_mapping'} />
                  <Route path={`dtcs/memos`} element={<MemoStore><Memos /></MemoStore>} key={'dtc_memos'} />
                  
                  <Route path={`connector_views`} element={<ConnectorViews />} key={'connector_views'} />
                  <Route path={`connector_views/new`} element={<ConnectorViewNew />} key={'connector_views_new'} />
                  <Route path={`connector_views/:connector_view/edit_mappings`} element={<ConnectorViewEditMappings />} key={'connector_views_edit_mappings'} />
                  <Route path={`connector_views/:connector_view/edit`} element={<ConnectorViewEdit />} key={'connector_views_edit'} />
                  <Route path={`connector_views/:connector_view/print`} element={<ConnectorViewMappingsPrintPage />} key={'connector_views_print'} />

                  <Route path={`power_distributions`} element={<PowerDistributions />} key={'power_distributions'} />
                  {/* Plugins submenu */}
                  <Route path={`plugins/sales_code_complexity`} element={<SalesCodeComplexityStore><SalesCodeComplexity /></SalesCodeComplexityStore>} key={'plugin_sales_code_complexity'} />
                  <Route path={`plugins/def`} element={<PluginStore><DefPlugin /></PluginStore>} key={'plugin_def'} />
                  <Route path={`plugins/capital_harness`} element={<CapitalHarnessStore><CapitalHarness /></CapitalHarnessStore>} key={'plugin_capital_harness'} />
                  
                  <Route path={`inlines`} element={<InlinesConnections />} key={'inlines'} />
                  <Route path={`modules`} element={<ModulesPage />} key={'modules'} />
                  <Route path={`devices`} element={<DevicePage />} key={'devices'} />
                  <Route path={`inspection_points`} element={<InSpectionPointsPage />} key={'inspection_points'} />
                  <Route path={`wire`} element={<WirePage />} key={'wires'} />
                  <Route path={`connector`} element={<ConnectorPage />} key={'connector'} />
                  <Route path={`sales_code`} element={<SalesCodesPage />} key={'sales_code'} />

                  <Route path={`functional-diagram`} element={<FunctionalDiagramPage />} key={'functional_diagram'} />
                  <Route path={`functional-diagram/:functional`} element={<FunctionalDiagramEditPage />} key={'functional_diagram_edit'} />

                  <Route path={`harnesses`} element={<HarnessListPage />} key={'harnesses'} />
                  <Route path={`circuit`} element={<CircuitPage />} key={'circuit'} />
                  <Route path={`device_connections`} element={<DeviceConnectionPage />} key={'device_connections'} />
                  {/* Validation submenu */}
                  <Route path={`validation/dtc_mapping_validation`} element={<DtcMappingErrorsPage />} key={'dtc_mapping_errors'} />
                  <Route path={`validation/graph_missing_images`} element={<GraphMissingImagesPage />} key={'graph_missing_images'} />

                  <Route path={`visual-aid`} element={<VisualAidPage />} key={'visual_aid'} />
                  <Route path="*" element={<NotFound />} key={'no_page'} />
                </Route>
                
                <Route path={`administration/`} element={<Administration />} key={'administration'} />
                <Route path={`system_and_sub_system/`} element={<SystemAndSubSystem />} key={'system_and_sub_system'} />
                <Route path={`customer_setup/`} element={<CustomerStore><Customer /></CustomerStore>} key={'customer_setup'} />
                <Route path={`usage_report/`} element={<UsageReport />} key={'usage_report'} />

                <Route path={`manage-update-list/`} element={<PromoteChangesPage />} key={'manage_update_list'} />
                <Route path={`manage-update-list/preview`} element={<TracerPreviewPage />} key={'manage_update_list_preview'} />
                <Route path={`manage-update-list/:branch/:vehicle/delete`} element={<DeletePromotedChangesPage />} key={'delete_manage_update_list'} />
                <Route path="*" element={<NotFound />} key={'no_page'} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  )
}
